import React from 'react';
import classNames from 'classnames';

import { Input, Select } from 'antd';

import './string-editor.less';

export default class Editor extends React.Component {
    render() {
        const {
            value,
            className,
            readOnly,
            disabled
        } = this.props;

        const options = this.getOptions();

        return (
            <span className={ classNames( 'string-editor', className ) }>
                {
                    options.length > 0 ? (
                        <Select
                            value={ value }
                            onChange={ this.handleSelectChange }
                            readOnly={ readOnly }
                            disabled={ disabled }
                        >
                            {
                                options.map( option => (
                                    <Select.Option key={ option } value={ option }>
                                        { option }
                                    </Select.Option>
                                ) )
                            }
                        </Select>
                    ) : (
                        <Input
                            value={ value }
                            onChange={ this.handleInputChange }
                            readOnly={ readOnly }
                            disabled={ disabled }
                        />
                    )
                }
            </span>
        );
    }

    handleInputChange = ( e )=> {
        const { onChange } = this.props;

        if ( typeof onChange === 'function' ) {
            onChange( e.target.value );
        }
    };
    handleSelectChange = ( value ) => {
        const { onChange } = this.props;

        if ( typeof onChange === 'function' ) {
            onChange( value );
        }
    };

    getOptions = () => {
        const { style } = this.props;

        // TODO: update branding service to store options for strings
        if ( style && style.propertyName === 'border-style' ) {
            return [
                'dotted',
                'dashed',
                'solid',
                'double',
                'groove',
                'ridge',
                'inset',
                'outset',
                'none',
                'hidden'
            ];
        }

        return [];
    };
}
